module.exports = "/assets/a84e04369c59081125050aa7ef985bd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/G4.png
// module id = 2517
// module chunks = 0